import React from "react";
import { AlertOctagon } from "lucide-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ error: null });
    if (typeof window !== "undefined") window.location.reload();
  };

  handleHome = () => {
    this.setState({ error: null });
    if (typeof window !== "undefined") window.location.href = "/";
  };

  render() {
    if (this.state.error) {
      return (
        <div
          className="min-h-screen flex items-center justify-center bg-[#F8F6F1] px-6"
          data-testid="error-boundary"
        >
          <div className="max-w-md text-center">
            <div className="w-12 h-12 rounded-xl bg-[#1F2326] flex items-center justify-center mx-auto mb-5">
              <AlertOctagon className="w-5 h-5 text-[#C76055]" strokeWidth={2.25} />
            </div>
            <h1 className="font-display text-2xl font-semibold text-[#1F2326]">
              Something went wrong on this page.
            </h1>
            <p className="text-sm text-[#69747C] mt-3">
              Your data is safe. Try refreshing — if it keeps happening, email{" "}
              <a className="text-[#B89B5E]" href="mailto:support@retainertracker.com">
                support@retainertracker.com
              </a>
              .
            </p>
            <div className="mt-7 flex items-center justify-center gap-2">
              <button
                type="button"
                onClick={this.handleReload}
                data-testid="error-reload-btn"
                className="bg-[#1F2326] text-[#F8F6F1] hover:bg-[#2A2E32] px-4 py-2 rounded-lg text-sm font-medium"
              >
                Refresh
              </button>
              <button
                type="button"
                onClick={this.handleHome}
                data-testid="error-home-btn"
                className="bg-white text-[#1F2326] border border-[#E4DFD2] hover:bg-[#FBFAF6] px-4 py-2 rounded-lg text-sm font-medium"
              >
                Back home
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
